export default function PackageFeatures() {
  const features = [
    {
      icon: 'ri-camera-line',
      title: 'Gravação Profissional',
      description: 'Estúdio equipado com iluminação profissional, áudio de alta qualidade e produtor.',
      bgColor: 'rgba(43,111,212,0.07)',
      iconColor: '#2B6FD4'
    },
    {
      icon: 'ri-scissors-cut-line',
      title: 'Edição Completa',
      description: 'Transição de câmeras para dar foco na fala do convidado, edição do vídeo e tratamento de áudio.',
      bgColor: 'rgba(0,191,255,0.08)',
      iconColor: '#00BFFF'
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Divulgação Estratégica',
      description: 'Publicação no YouTube, Spotify e card no feed das redes sociais.',
      bgColor: 'rgba(26,58,143,0.06)',
      iconColor: '#1A3A8F'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Posicionamento Digital',
      description: 'Seu episódio como ferramenta de autoridade, credibilidade e networking qualificado no ecossistema de inovação',
      bgColor: 'rgba(43,111,212,0.1)',
      iconColor: '#2B6FD4'
    }
  ];

  return (
    <section className="py-24 relative" style={{ background: 'linear-gradient(180deg, #f0f5ff 0%, #ffffff 100%)' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{ background: 'rgba(43,111,212,0.1)', color: '#1A3A8F' }}>
            <span className="font-semibold text-sm whitespace-nowrap">Pacote Completo por Episódio •</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2">
            Tudo que você precisa
          </h2>
          <h2 className="text-4xl md:text-5xl font-serif italic" style={{ color: '#2B6FD4' }}>
            para um episódio profissional
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {features.map((feature, index) => (
            <div
              key={index}
              className="rounded-3xl p-8 hover:shadow-lg transition-all hover:-translate-y-1"
              style={{ background: feature.bgColor }}
            >
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-5xl`} style={{ color: feature.iconColor }}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-700 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Additional Benefits */}
        <div className="rounded-3xl p-8 md:p-12 text-white" style={{ background: 'linear-gradient(135deg, #1A3A8F 0%, #2B6FD4 60%, #00BFFF 100%)' }}>
          <h3 className="text-2xl md:text-3xl font-bold mb-8 text-center">Benefícios Adicionais Inclusos</h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-1" style={{ background: 'rgba(255,255,255,0.2)' }}>
                <i className="ri-check-line text-white"></i>
              </div>
              <div>
                <h4 className="font-bold mb-1">Preparação Pré-Gravação</h4>
                <p className="text-white/90 text-sm">Reunião prévia para alinhar temas, pontos-chave e estrutura do episódio</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-1" style={{ background: 'rgba(255,255,255,0.2)' }}>
                <i className="ri-check-line text-white"></i>
              </div>
              <div>
                <h4 className="font-bold mb-1">Material de Divulgação</h4>
                <p className="text-white/90 text-sm">Cards personalizados, post no feed e materiais prontos para suas redes sociais</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-1" style={{ background: 'rgba(255,255,255,0.2)' }}>
                <i className="ri-check-line text-white"></i>
              </div>
              <div>
                <h4 className="font-bold mb-1">Networking Qualificado</h4>
                <p className="text-white/90 text-sm">Conexão com audiência engajada de empreendedores e líderes da região</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-1" style={{ background: 'rgba(255,255,255,0.2)' }}>
                <i className="ri-check-line text-white"></i>
              </div>
              <div>
                <h4 className="font-bold mb-1">Visibilidade no Ecossistema</h4>
                <p className="text-white/90 text-sm">Alcance qualificado entre empreendedores, investidores e líderes da Amazônia</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
